/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shift_Line_Forward_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Shift Line Down" |
*
* @param {Shift_Line_Forward_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shift_line_forward_aria_label = /** @type {((inputs?: Shift_Line_Forward_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shift_Line_Forward_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Decaler la Ligne en Bas")
	if (locale === "de") return /** @type {LocalizedString} */ ("Schichtleitung nach unten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sposta la linea verso il basso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Сдвиг линии вниз")
	if (locale === "es") return /** @type {LocalizedString} */ ("Desplazar línea hacia abajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("换线向下")
	if (locale === "ja") return /** @type {LocalizedString} */ ("シフトラインダウン")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लाइन को नीचे खिसकाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Linha de mudança para baixo")
	return /** @type {LocalizedString} */ ("Shift Line Down")
});